import {
    useAuthManager,
    useAutoOpenPaymentWidget,
    useFeatureFlags,
} from '@funtech-int/yango-shared';

import { useProfileManager } from '@/shared/hooks/useProfileManager';
import { useSearchParams } from '@/shared/hooks/useSearchParams';

import { featureFlagsScheme } from '../lib/featureFlags';

export const useAutoOpenPaymentWidgetParams = () => {
    const { isAuthorized } = useAuthManager();
    const { hasSpecificSubscription } = useProfileManager();
    const searchParams = useSearchParams();

    const { flags } = useFeatureFlags(featureFlagsScheme);
    const isPaymentWidgetAutoOpenFromUrl = flags.get('isPaymentWidgetAutoOpenFromUrl');

    const { shouldOpenWidget, target, billingFeatureName, clearParams } = useAutoOpenPaymentWidget({
        isAuthorized,
        hasSpecificSubscription,
        isUrlSourceEnabled: isPaymentWidgetAutoOpenFromUrl,
    });

    const watchAfterPurchaseQueryParam = searchParams.get('watchAfterPurchase') ?? undefined;

    return {
        shouldOpenWidget,
        target,
        billingFeatureName,
        clearParams,
        watchAfterPurchase: watchAfterPurchaseQueryParam,
    };
};
